<template>
    <div id="printMeTesellum">
        <table style="width: 100% !important; text-align: center">
            <tr>
                <th
                style="text-align: center;border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Fatura No
                </th>
                <th
                style="
                    text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Sipariş No
                </th>
                <th
                style="text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Teslimat İli
                </th>
                <th
                style="
                    text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Teslimat İlçesi
                </th>
                <th
                style="
                    text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Teslimat Adresi
                </th>
                <th
                style="text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Teslimat Adı
                </th>
                <th
                style="text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Kargo Adı
                </th>
                <th
                style="text-align: center;
                    border-bottom: 1px solid grey;
                    padding: 3px;
                "
                >
                Kargo Takip Kodu
                </th>
            </tr>

            <tr :key="indextr" v-for="(tr, indextr) in tesellumList">
                <td style="padding: 8px">
                {{ tr.receiptno }}
                </td>
                <td style="padding: 8px">
                {{ tr.orderNumber }}
                </td>
                <td style="padding: 8px">
                {{ tr.shipCity }}
                </td>
                <td style="padding: 8px" > {{ tr.shipDistrict}} </td>
                <td style="padding: 8px">{{ tr.shipFullAddress }} </td>
                <td style="padding: 8px;" >{{ tr.shipFullName }}</td>
                <td style="padding: 8px;" >{{ tr.cargoProviderName }}</td>
                <td style="padding: 8px;" >{{ tr.cargoTrackingNumber }}</td>
            </tr>
        </table>
    </div>
</template>
<script>
export default {
data(){return{tesellumList:[]}},
methods:{
    yazdir() {
      setTimeout(this.yazdirBekle, 1000);
    },
    yazdirBekle() {
      this.$htmlToPaper("printMeTesellum");
    },
    tesellumListGet(tesellumList){
        console.log(tesellumList)
        this.tesellumList=tesellumList;
    }
}
}
</script>